var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMccFullLogoNetoHq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 210.9,
    height: 98.03,
    viewBox: "0 0 210.9 98.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7643",
    "data-name": "Rectangle 7643",
    width: 210.9,
    height: 98.03,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MCC_-_Vert_-_Colour",
    "data-name": "MCC - Vert - Colour",
    transform: "translate(105.45 49.015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MCC_-_Vert_-_Colour-2",
    "data-name": "MCC - Vert - Colour",
    transform: "translate(-105.45 -49.015)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_267021",
    "data-name": "Path 267021",
    d: "M206.3,80.9a1.7,1.7,0,1,1,1.7-1.7,1.6,1.6,0,0,1-1.7,1.7m0-3.1a1.3,1.3,0,1,0,.956.415,1.3,1.3,0,0,0-.956-.415m-.3,2.4h-.3V78.3h.7c.5,0,.7.2.7.5a.5.5,0,0,1-.5.5l.5.8h-.3l-.5-.8H206Zm.3-1.1c.2,0,.4,0,.4-.3s-.2-.3-.4-.3H206V79Z",
    fill: "#1e2533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267022",
    "data-name": "Path 267022",
    d: "M98.2,81.5C90.1,81.5,86,77.2,86,68.7c0-10.8,6.7-13.1,12.2-13.1,8,0,12.2,4.5,12.2,13.1s-4.1,12.9-12.2,12.9m0-22.6c-4.9,0-8.2,1.7-8.2,9.8s4,9.5,8.3,9.5,8.2-1.2,8.2-9.5S103.1,59,98.2,59",
    fill: "#1e2533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267023",
    "data-name": "Path 267023",
    d: "M150.6,81.5c-8.1,0-12.2-4.3-12.2-12.9,0-10.8,6.7-13.1,12.2-13.1,8,0,12.2,4.5,12.2,13.1s-4.1,12.9-12.2,12.9m0-22.6c-5,0-8.2,1.7-8.2,9.8s4,9.5,8.3,9.5,8.2-1.2,8.2-9.5-3.3-9.8-8.2-9.8",
    fill: "#1e2533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267024",
    "data-name": "Path 267024",
    d: "M31.3,81.2H28.6A1.185,1.185,0,0,1,27.5,80L25.3,61.1,18.1,80c-.2.5-.6,1.2-1.1,1.2H14.4c-.7,0-1-.8-1.3-1.3v-.2L6,61.1,3.8,80a1.185,1.185,0,0,1-1.1,1.2H0L2.8,56.8c.2-.8.8-.9,1.4-.9H6.6a1.147,1.147,0,0,1,1.3.8l7.8,20.1,7.8-20.1a1.147,1.147,0,0,1,1.3-.8h2.4c.6,0,1.2.1,1.4.9Z",
    fill: "#1e2533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267025",
    "data-name": "Path 267025",
    d: "M58.1,81.2H55.4a1.6,1.6,0,0,1-1.7-1l-1.9-4.9H43.4l1.3-3.2h5.9L48,65.4c-.7-1.8-1.3-3.9-1.7-4.9-.3,1-1,3.1-1.7,4.9L38.8,80.1A1.6,1.6,0,0,1,37,81.2H34.4l9.9-24.7c.3-.5.5-.6,1.2-.6h1.8c.9,0,1.1.3,1.4,1v.2Z",
    fill: "#1e2533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267026",
    "data-name": "Path 267026",
    d: "M70,68.4h2.4c4,0,5.7-.7,5.7-4.6s-1.4-4.6-5.7-4.6H66.2a.8.8,0,0,0-.7.7v20a1.5,1.5,0,0,1-1.4,1.3H61.7V58.1c0-1.4.7-2.2,2-2.2h9.2c6.1,0,9.2,2.6,9.2,7.8s-2.1,6.9-6.3,7.9l-2.2.2,8.8,8.5c.2.3.3.5.2.7s-.2.3-.6.3H79.3a1.5,1.5,0,0,1-.9-.3l-9.6-9.2c-.7-.7-1.1-1.5-.5-2.4a2,2,0,0,1,1.8-.9",
    fill: "#1e2533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267027",
    "data-name": "Path 267027",
    d: "M117.2,81.2h-2.4V58.1a2,2,0,0,1,1.9-2.2h8.8c6.6,0,10,3,10,8.8s-3.3,8.8-10.1,8.8h-4.2V70.1h3.7c5,0,6.5-1.3,6.5-5.2s-1.6-5.6-6.5-5.6h-5.6a.8.8,0,0,0-.8.7V79.8a1.5,1.5,0,0,1-1.4,1.4",
    fill: "#1e2533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267028",
    "data-name": "Path 267028",
    d: "M177.9,81.2h-12V81c0-.1.7-3.1,2.8-3.1H178c3,0,4.5-1,4.5-3.2a2.6,2.6,0,0,0-1.7-2.3l-3.6-1.5L170.4,68l-.6-.3c-2.2-1-4.3-2-4.3-5.2s3.2-6.7,8.4-6.7h11.4v.3c0,.1-1,3.1-3.4,3.1h-8.3c-2.3,0-4.6.9-4.6,3s1.3,2.1,3.2,2.9l.9.4,3.4,1.5,6.5,2.8a4.8,4.8,0,0,1,3,4.6c0,4.2-3.1,6.7-8.3,6.7",
    fill: "#1e2533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267029",
    "data-name": "Path 267029",
    d: "M199.4,81.2H197V59.3h-9.9V59c0-.1.9-3.1,3.4-3.1h20.3v.2s-.4,3.1-3.1,3.1h-7V79.8a1.5,1.5,0,0,1-1.4,1.4",
    fill: "#1e2533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267030",
    "data-name": "Path 267030",
    d: "M119.8,24.4,128.7,7a1.8,1.8,0,0,0-1.5-2.7H91.5L91.1,0H82V.2A2.8,2.8,0,0,0,84.8,3h3.6l3,27.2a6.3,6.3,0,1,0,8.9,1.8h11a6.2,6.2,0,1,0,5.8-2.9H94.2l-.4-3.4h24a2.2,2.2,0,0,0,2-1.2M95,38.5a3.3,3.3,0,1,1,3.3-3.3A3.3,3.3,0,0,1,95,38.5m24.9-3.3a3.3,3.3,0,1,1-3.3-3.3,3.3,3.3,0,0,1,3.3,3.3M93.5,22.6,91.9,7.2h33.3l-7.8,15.4Z",
    fill: "#03b6fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267031",
    "data-name": "Path 267031",
    d: "M13.3,93.3a4.7,4.7,0,0,1,4.9-4.7,4.6,4.6,0,0,1,3.6,1.5l-1.1,1a3.2,3.2,0,1,0,0,4.2l1.1,1A4.6,4.6,0,0,1,18.2,98a4.7,4.7,0,0,1-4.9-4.7",
    fill: "#7d90b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267032",
    "data-name": "Path 267032",
    d: "M26.5,93.3a4.7,4.7,0,1,1,1.447,3.4A4.7,4.7,0,0,1,26.5,93.3m8.1,0a3.2,3.2,0,1,0-3.2,3.2,3.1,3.1,0,0,0,3.2-3.2",
    fill: "#7d90b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267033",
    "data-name": "Path 267033",
    d: "M50.5,97.9l-.1-6.1-3,5.1h-.7l-3-5v6H42.1V88.8h1.4l3.6,6,3.6-6h1.4v9.1Z",
    fill: "#7d90b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267034",
    "data-name": "Path 267034",
    d: "M66.8,97.9V91.8l-3,5.1h-.7l-3-5v6H58.5V88.8h1.3l3.7,6,3.5-6h1.4l.1,9.1Z",
    fill: "#7d90b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267035",
    "data-name": "Path 267035",
    d: "M81.7,96.5v1.4H74.8V88.8h6.7v1.4h-5v2.4H81V94H76.5v2.5Z",
    fill: "#7d90b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267036",
    "data-name": "Path 267036",
    d: "M93.5,97.9l-1.9-2.7H89.2v2.7H87.5V88.8h3.8c2.4,0,3.9,1.2,3.9,3.3A2.9,2.9,0,0,1,93.3,95l2.1,3Zm-2.3-7.7h-2v3.6h2c1.5,0,2.3-.7,2.3-1.8s-.8-1.8-2.3-1.8",
    fill: "#7d90b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267037",
    "data-name": "Path 267037",
    d: "M100.3,93.3a4.9,4.9,0,0,1,8.5-3.2l-1.1,1a3.2,3.2,0,1,0,0,4.2l1.1,1a4.9,4.9,0,0,1-8.5-3.2",
    fill: "#7d90b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267038",
    "data-name": "Path 267038",
    d: "M121.2,96.5v1.4h-6.8V88.8H121v1.4h-4.9v2.4h4.4V94h-4.4v2.5Z",
    fill: "#7d90b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267039",
    "data-name": "Path 267039",
    d: "M133.9,93.3a4.9,4.9,0,0,1,8.5-3.2l-1.1,1a3.2,3.2,0,1,0,0,4.2l1.1,1a4.9,4.9,0,0,1-8.5-3.2",
    fill: "#7d90b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267040",
    "data-name": "Path 267040",
    d: "M148,88.8h1.7v7.7h4.7v1.4H148Z",
    fill: "#7d90b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267041",
    "data-name": "Path 267041",
    d: "M158.9,93.3a4.9,4.9,0,1,1,4.9,4.7,4.7,4.7,0,0,1-4.9-4.7m8.1,0a3.2,3.2,0,1,0-3.2,3.2,3.1,3.1,0,0,0,3.2-3.2",
    fill: "#7d90b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267042",
    "data-name": "Path 267042",
    d: "M174.4,93.9V88.8h1.7v5.1c0,1.9.8,2.7,2.3,2.7s2.3-.8,2.3-2.7V88.8h1.7V94c0,2.7-1.5,4.1-4,4.1s-4-1.4-4-4.1",
    fill: "#7d90b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267043",
    "data-name": "Path 267043",
    d: "M188.7,88.8h4c3,0,5,1.8,5,4.6s-2,4.6-5,4.6h-4Zm3.9,7.7a3.15,3.15,0,0,0,0-6.3h-2.2v6.3Z",
    fill: "#7d90b8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccFullLogoNetoHq);
export default __webpack_public_path__ + "static/media/MCC-Full-Logo_netoHQ.13886a4f9ad03a3c62e2e7ae96dc0bc4.svg";
export { ForwardRef as ReactComponent };